import {Component} from 'react'
import { isDeviceId } from '../Report/Model/isType';

export default class csvImport extends Component {
  constructor(props) {
    super(props);

    // file property names to internal names
    this.csvMap = { "RADIO ID":"device_id" ,"TYPE":"type",
          "SENSOR TYPE":"sensors.0.display_type","SENSOR":"","NODE ID":"node_id",
          "ADDRESS":"address", "BUILDING":"building","APT":"apt",
          "LOCATION NOTE":"location_note", "COUNT FACTOR":"sensors.0.factor",
          "UNITS":"sensors.0.units","METER TYPE":"sensors.0.meter_type",
          "METER STYLE":"sensors.0.meter_style","METER NOTE":"sensors.0.note", 
          "METER SERIAL NUMBER":"sensors.0.meter_serial_number",
          "INITIAL METER READING":"sensors.0.initial_meter_read",
          "INITIAL METER TIME":"sensors.0.initial_meter_time",
    }
  }
  mapToAPI (data) {
    return data.map (item => {
      const entries = Object.entries(item)
      const apiEntries = entries.map (k=>[this.csvMap[k[0].toUpperCase()], k[1]])
      return Object.fromEntries(apiEntries)
    })
  }
  checkFileCols (data) {
    if (Array.isArray(data) && data.length > 0) {
      let keys = Object.keys(data[0])
      const max = Object.keys(this.csvMap).length
      if (keys.length > max)
        keys.length = max
      return keys.filter(k=>this.csvMap[k.toUpperCase()] === undefined)
    }
    return undefined
  }
  checkDeviceId(data) {
    if (Array.isArray(data) && data.length > 0) {
      const keys = Object.keys(data[0])
      const givenName = keys.find(k=>k.toUpperCase() === 'RADIO ID')
      let result = []
      data.forEach ((row, rowNum) => {
        if (this.hasContent (row)) {
          if (!isDeviceId(row[givenName]))
            result.push(rowNum+2)   // +2 because 0 origin and title row removed
        }
      })
      return result
    }
    return undefined
  }
  hasContent(row) {
    const values = Object.values(row)
    const content = values.reduce ((accum, current) => accum+(current??''), '')
    return content && content.length > 0
  }
}

